import { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations, LANGS } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const initial = (typeof window !== "undefined" && localStorage.getItem("boe_lang")) || "de";
  const [lang, setLangState] = useState(LANGS.find((l) => l.code === initial) ? initial : "de");

  const setLang = useCallback((code) => {
    setLangState(code);
    if (typeof window !== "undefined") localStorage.setItem("boe_lang", code);
  }, []);

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang], langs: LANGS }),
    [lang, setLang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
